"use strict";
/**
 * @module Services.Control
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Data type for a MESSAGING_SEND request.
 */
var MessagingSendRequest = /** @class */ (function () {
    /**
     * Create a new MessagingSendRequest instance
     *
     * @param path  the message path
     * @param dataType  the datatype of the message
     * @param request  the message data
     */
    function MessagingSendRequest(path, dataType, request) {
        this.path = path;
        this.dataType = dataType;
        this.request = request;
    }
    return MessagingSendRequest;
}());
exports.MessagingSendRequest = MessagingSendRequest;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/control/messaging-send-request.js
// module id = 1909
// module chunks = 1